import React, { VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import {
  ABOUT,
  BUSINESSES,
  PLANS,
  EXPERIENCE,
  BUSINESS,
} from '../../../routing';
import { useTheme, Theme } from '@material-ui/core/styles';
import GreenButtonLink from '../atoms/GreenButtonLink';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #f5f3f3;
`;
const Link = styled.a<{ color: string; theme: Theme }>`
  font-size: 15px;
  color: ${({ color }) => color};
  margin-right: ${({ theme }) => theme.spacing(5)}px;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: ${({ color }) => color};
    text-underline-offset: 5px;
  }
`;
const BusinessLinkWrapper = styled.div`
  position: absolute;
  right: 5%;
`;

interface Props {}
const SubHeader: VFC<Props> = (props: Props) => {
  const theme = useTheme();
  return (
    <Wrapper>
      <Link href={ABOUT} color="#fe6e2d" theme={theme}>
        {T.translate('header.about')}
      </Link>
      <Link href={BUSINESSES} color="#26bcba" theme={theme}>
        {T.translate('header.businesses')}
      </Link>
      <Link href={PLANS} color="#3e71ce" theme={theme}>
        {T.translate('header.plans')}
      </Link>
      <Link
        href={EXPERIENCE}
        color="#d87235"
        target="_blank"
        rel="noopener"
        theme={theme}
      >
        {T.translate('header.experience')}
      </Link>
      <BusinessLinkWrapper>
        <GreenButtonLink href={BUSINESS} target="_blank">
          {T.translate('header.business')}
        </GreenButtonLink>
      </BusinessLinkWrapper>
    </Wrapper>
  );
};

export default SubHeader;
